<template>
    <DevelopmentGoalCard :goal="goal" label="Draft" />
</template>

<script setup lang="ts">
import DevelopmentGoalCard from "~vue/ChatDetail/DevelopmentGoalCard.vue";
import type { DevelopmentGoalDraft } from "~vue/types/chat";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const props = defineProps<{ goal: DevelopmentGoalDraft; coachingSessionUuid?: string | null }>();

onMounted(() => {
    void logUserInteraction(AmplitudeEventNames.DEVELOPMENT_JOURNEYS_GOAL_CARD_VIEWED, {}, props.coachingSessionUuid ?? undefined);
});
</script>
